// reducers/counterReducer.js
import { createSlice } from '@reduxjs/toolkit'
const editInductionSlice = createSlice({
  name:"EditInduction",
  initialState:false,
  reducers:{
    EditInduction(state,action){
      return action.payload;
    },
    ResetEditInduction(){
      return null
    }
  }
}) 
export default editInductionSlice.reducer;
export const {EditInduction,ResetEditInduction}=editInductionSlice.actions;